






















































































import Vue from 'vue'
import Progress from '@/components/common/Progress.vue'
import {
  defaultPosterImage,
  MOBILE_CATEGORY_ITEM_HEADING_MAX_LENGTH
} from '../../helper/constants'
import { getMobileTheme } from '@/helper'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'

export default Vue.extend({
  props: {
    category: {
      type: Object,
      required: true
    },
    progress: {
      type: Number
    },
    notAvailable: {
      type: Boolean,
      default: false
    },
    categoryProgressCount: {
      type: Object
    }
  },
  components: {
    Progress,
    BaseIcon
  },
  computed: {
    device(): string {
      return this.$store.getters.device
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    },
    isBuilder(): boolean {
      return this.$route.query.builder === 'true'
    }
  },
  data() {
    return {
      defaultPosterImage,
      headingLimit: MOBILE_CATEGORY_ITEM_HEADING_MAX_LENGTH
    }
  },
  methods: {
    getMobileTheme
  }
})
